var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C24.0666 0 18.2664 1.75947 13.3329 5.05591C8.39943 8.35235 4.55426 13.0377 2.28363 18.5195C0.0129986 24.0013 -0.581101 30.0333 0.576455 35.8527C1.73401 41.6721 4.59123 47.0176 8.78681 51.2132C12.9824 55.4088 18.3279 58.266 24.1473 59.4235C29.9667 60.5811 35.9987 59.987 41.4805 57.7164C46.9623 55.4457 51.6477 51.6006 54.9441 46.6671C58.2405 41.7336 60 35.9334 60 30C59.9912 22.0462 56.8276 14.4207 51.2035 8.79654C45.5793 3.17236 37.9538 0.00882284 30 0ZM53.3333 30C53.3382 35.0369 51.7051 39.9389 48.6806 43.9667L16.0333 11.3194C19.501 8.72834 23.6211 7.15296 27.9329 6.76947C32.2447 6.38598 36.5781 7.2095 40.4487 9.14793C44.3192 11.0864 47.5742 14.0633 49.8496 17.7458C52.1251 21.4283 53.3313 25.6712 53.3333 30ZM6.66668 30C6.66186 24.963 8.29487 20.0611 11.3195 16.0333L43.9667 48.6805C40.499 51.2716 36.3789 52.847 32.0671 53.2305C27.7553 53.614 23.4219 52.7905 19.5514 50.8521C15.6808 48.9136 12.4258 45.9367 10.1504 42.2542C7.87493 38.5717 6.66873 34.3288 6.66668 30Z",
    fill: "#F1EFEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/noChat.56a068e0674bda7c3ddfb7b9c29c7f1f.svg";
export { ForwardRef as ReactComponent };